module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', [_vm._v("Because this is a personal webpage, I have to include a picture of my beautiful cat.  His name is Leonidas. He got the name for three reasons.  First, it starts with \"Leo,\" and he looks like a baby lion. Second, when I adopted him, he was afraid of everything, and he needed the inspiration. Third, he showed an early disposition to blockade doors, and I'm pretty sure that if I'd also adopted a Persian, that cat would never have been allowed to pass.")]), _vm._v(" "), _c('p', [_vm._v("Affiliations past, present, and future include the "), _c('a', {
    attrs: {
      "href": "https://integrityinstitute.org"
    }
  }, [_vm._v("Integrity Institute")]), _vm._v(" (Founding Fellow, 2021-; Board Member 2021-08/2024), the "), _c('a', {
    attrs: {
      "href": "https://www.ias.edu/"
    }
  }, [_vm._v("Institute for Advanced Study")]), _vm._v(" (Member, School of Social Science, 2014-5), the "), _c('a', {
    attrs: {
      "href": "https://www.recurse.com/"
    }
  }, [_vm._v("Recurse Center")]), _vm._v(" (summer 2 batch 2017, for more see the tech page on this site), the University College Cork "), _c('a', {
    attrs: {
      "href": "https://www.ucc.ie/en/classics/summerschool/"
    }
  }, [_vm._v("Attic Greek summer intensive")]), _vm._v(" (where I learned Greek in 2013), and, long, long ago, the Cal State LA "), _c('a', {
    attrs: {
      "href": "http://www.calstatela.edu/academic/eep"
    }
  }, [_vm._v("Early Entrance Program")]), _vm._v(". For several years, I served on the Iowa City "), _c('a', {
    attrs: {
      "href": "https://www.icgov.org/city-government/boards/telecommunications-commission"
    }
  }, [_vm._v("Telecommunications Commission")]), _vm._v(", and I have consulted a bit with Facebook (2018-9) relative to the company's election integrity efforts and the design of the Oversight Board.")]), _vm._v(" "), _c('p', [_vm._v("I'm a former civil rights and legal aid lawyer. In those contexts, I represented victims of police misconduct, predatory lending, employment discrimination, unlawful eviction, domestic violence, and numerous other injustices. I've been admitted to the bars of Louisiana, Massachusetts, Oregon, and Virginia, though I'm not on active status with any of them.")]), _vm._v(" "), _c('p', [_vm._v("My legal advocacy, scholarship, and technology work is inseparable from advocacy for social justice and racial, economic, and gender equality.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64594b12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/bio2-4.vue
// module id = 198
// module chunks = 0